import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { INTERNATIONAL_PHONE_CODE } from 'src/app/core/config';
import { APP_ROUTES } from 'src/app/core/config/routes';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-register-otp',
  templateUrl: './register-otp.component.html',
  styleUrls: ['./register-otp.component.scss']
})
export class RegisterOtpComponent implements OnInit {
  @ViewChildren('otpInput') otpInputs: QueryList<ElementRef>;

  phoneNumber: number;
  otpCode: string = '';
  isValid: boolean = false;
  digits: string[] = ['', '', '', '', '', ''];

  phoneCode = INTERNATIONAL_PHONE_CODE;

  timeLeft: number = 180;
  interval;
  canResend: boolean = false;
  state: { [k: string]: any; };

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private sharedService: SharedService,
    private layoutService: LayoutService
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.state = navigation.extras.state;
  }

  ngOnInit(): void {
    if (!this.state) {
      this.router.navigate([APP_ROUTES.AUTH.REGISTER]);
    }
    this.startTimer();
  }

  onDigitInput(event: any, index: number) {
    const value = event.target.value.replace(/\D/g, '');
    this.digits[index] = value ? value.charAt(0) : '';
    event.target.value = this.digits[index];
    this.updateOtpCode();

    if (value && index < 5) {
      const inputs = this.otpInputs.toArray();
      inputs[index + 1].nativeElement.focus();
    }
  }

  onDigitKeydown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace') {
      if (!this.digits[index] && index > 0) {
        const inputs = this.otpInputs.toArray();
        this.digits[index - 1] = '';
        inputs[index - 1].nativeElement.focus();
        inputs[index - 1].nativeElement.value = '';
        this.updateOtpCode();
        event.preventDefault();
      }
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const paste = event.clipboardData?.getData('text')?.replace(/\D/g, '') || '';
    if (paste.length > 0) {
      const chars = paste.split('').slice(0, 6);
      const inputs = this.otpInputs.toArray();
      chars.forEach((char, i) => {
        this.digits[i] = char;
        if (inputs[i]) {
          inputs[i].nativeElement.value = char;
        }
      });
      this.updateOtpCode();
      const focusIndex = Math.min(chars.length, 5);
      inputs[focusIndex].nativeElement.focus();
    }
  }

  private updateOtpCode() {
    this.otpCode = this.digits.join('');
    this.isValid = this.otpCode.length === 6;
  }

  formatTime(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  }

  resendOtp() {
    this.timeLeft = 180;
    this.canResend = false;
    this.startTimer();
    this.authService.sendOtp(this.state.phoneNumber, this.state.type).subscribe((response) => {
      console.log(response);
    });
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.canResend = true;
        this.pauseTimer();
      }
    }, 1000);
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  register() {
    this.authService.signUp(this.state.type, { ...this.state, otp: this.otpCode }).subscribe(
      (data) => {
        console.log(data);
        this.toastr.success('تمت العملية بنجاح ! مرحبا بك');
        this.sharedService.changeSignUpStatus('RESET');
        this.router.navigate([APP_ROUTES.AUTH.LOGIN], { queryParams: { type: this.state.type } });
      }, err => {
        this.otpCode = '';
        this.digits = ['', '', '', '', '', ''];
        this.isValid = false;
      }
    );
  }

  login() {
    const requestData = {
      phoneNumber: this.phoneCode + this.phoneNumber,
      otp: this.otpCode
    };

    this.authService.signin(this.authService.type, requestData).subscribe(
      (response: any) => {
        if (!this.sharedService?.isMock) {
          localStorage.setItem('user', JSON.stringify(response.data.user));
          localStorage.setItem('token', response.data.token);
        }
        this.toastr.success('! تم تسجيل الدخول بنجاح');
        this.layoutService.initializeSidebarListenners();
        this.router.navigate(['/']);
      },
      (error) => {
        this.toastr.warning('أرسلنا رمز التفعيل إلى الهاتف');
      }
    );
  }
}
